export enum Languages {
    en = "en",
    de = "de",
    fr = "fr",
}
